var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "exercise-cards" }, [
    _c(
      "div",
      { staticClass: "exercise-cards-main" },
      [
        _c(
          "transition",
          {
            attrs: {
              mode: "out-in",
              name:
                _vm.activeExerciseIndex > 1 && _vm.direction === "right"
                  ? "slide-fade-list-right"
                  : "",
            },
          },
          [
            _c("stacked-card", { key: _vm.activeExerciseIndex }, [
              _c(
                "div",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _vm.exercises.length > 0
                    ? _c(
                        "paragraph",
                        {
                          staticClass: "effort-text",
                          attrs: { type: "p", variation: "label" },
                        },
                        [_vm._v("\n            Effort\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { class: ["effort-label", _vm.effortColor] }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.effortType.toUpperCase()) +
                        "\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isManualAssurance
                    ? _c("div", { staticClass: "manual-assurance-card" }, [
                        _c("span", [_vm._v("MANUAL ASSURANCE")]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _vm.exercises.length > 0
                    ? _c(
                        "div",
                        { staticClass: "stacked-card-body-title" },
                        [
                          _c("paragraph", { attrs: { type: "p" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.exercises[_vm.activeExerciseIndex].title
                                ) +
                                "\n            "
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.exercises.length > 0
                    ? _c("custom-button", {
                        attrs: {
                          text: "Open details",
                          size: "button-medium",
                          type: "achromatic-dark",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openDetails(_vm.activeExerciseIndex)
                          },
                        },
                      })
                    : _c(
                        "div",
                        { staticClass: "stacked-card-body-spinner" },
                        [
                          _vm.isFetchingData
                            ? _c("i", { staticClass: "fa fa-spinner fa-pulse" })
                            : _c("paragraph", {
                                staticClass: "stacked-card-body-empty-message",
                                attrs: { type: "p" },
                                domProps: {
                                  innerHTML: _vm._s(_vm.emptyMessage),
                                },
                              }),
                        ],
                        1
                      ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.exercises.length > 0
                ? _c(
                    "div",
                    {
                      staticClass: "stacked-card-footer",
                      attrs: { slot: "footer" },
                      slot: "footer",
                    },
                    [
                      _c("div", { staticClass: "hackability-share" }, [
                        _c("p", [_vm._v("Hackability %")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.exercises[_vm.activeExerciseIndex]
                                  .hackability_share
                              ) +
                              "%\n            "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "number-of-hosts" }, [
                        _c("p", [_vm._v("# of hosts")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "font-weight-bold" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.exercises[_vm.activeExerciseIndex]
                                  .number_of_affected_hosts
                              ) +
                              "\n            "
                          ),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _vm.activeExerciseIndex - 1 !== -1 && _vm.exercises.length !== 0
          ? _c(
              "transition",
              {
                attrs: {
                  name:
                    _vm.direction === "right" && _vm.activeExerciseIndex !== 1
                      ? ""
                      : _vm.activeExerciseIndex > 0 && _vm.direction === "left"
                      ? "slide-fade-list-left"
                      : "slide-fade-right",
                },
              },
              [
                _c("stacked-card", { key: _vm.activeExerciseIndex }, [
                  _c(
                    "div",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _vm.exercises.length > 0
                        ? _c(
                            "paragraph",
                            {
                              staticClass: "effort-text",
                              attrs: { type: "p", variation: "label" },
                            },
                            [_vm._v("\n            Effort\n          ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { class: ["effort-label", _vm.effortColor] }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.effortType.toUpperCase()) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.isManualAssurance
                        ? _c("div", { staticClass: "manual-assurance-card" }, [
                            _c("span", [_vm._v("MANUAL ASSURANCE")]),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _vm.exercises.length > 0
                        ? _c(
                            "div",
                            { staticClass: "stacked-card-body-title" },
                            [
                              _c("paragraph", { attrs: { type: "p" } }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.exercises[_vm.activeExerciseIndex - 1]
                                        .title
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.exercises.length > 0
                        ? _c("custom-button", {
                            attrs: {
                              text: "Open details",
                              size: "button-medium",
                              type: "achromatic-dark",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openDetails(
                                  _vm.activeExerciseIndex - 1
                                )
                              },
                            },
                          })
                        : _c(
                            "div",
                            { staticClass: "stacked-card-body-spinner" },
                            [
                              _vm.isFetchingData
                                ? _c("i", {
                                    staticClass: "fa fa-spinner fa-pulse",
                                  })
                                : _c("paragraph", {
                                    staticClass:
                                      "stacked-card-body-empty-message",
                                    attrs: { type: "p" },
                                    domProps: {
                                      innerHTML: _vm._s(_vm.emptyMessage),
                                    },
                                  }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.exercises.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "stacked-card-footer",
                          attrs: { slot: "footer" },
                          slot: "footer",
                        },
                        [
                          _c("div", { staticClass: "hackability-share" }, [
                            _c("p", [_vm._v("Hackability %")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.exercises[_vm.activeExerciseIndex - 1]
                                      .hackability_share
                                  ) +
                                  "%\n            "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "number-of-hosts" }, [
                            _c("p", [_vm._v("# of hosts")]),
                            _vm._v(" "),
                            _c("p", { staticClass: "font-weight-bold" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.exercises[_vm.activeExerciseIndex - 1]
                                      .number_of_affected_hosts
                                  ) +
                                  "\n            "
                              ),
                            ]),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ],
              1
            )
          : _c(
              "transition",
              { attrs: { name: "slide-fade-left", mode: "out-in" } },
              [
                _c("title-card", [
                  _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                    _c("img", {
                      staticClass: "autobahn-logo",
                      attrs: {
                        src: "/assets/images/Autobahn_vertical_combination_mark_black.png",
                        alt: "autobahn-logo-vertical",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "body" }, slot: "body" },
                    [
                      _c("heading", { attrs: { level: "h3" } }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.titleBody) +
                            "\n          "
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "footer" }, slot: "footer" },
                    [
                      _c(
                        "paragraph",
                        { attrs: { type: "p", variation: "small" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.titleFooter) +
                              "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "exercise-cards-pagination" }, [
      _c(
        "div",
        {
          staticClass: "exercise-cards-pagination-item",
          class: {
            inactive:
              _vm.activeExerciseIndex === 0 || _vm.exercises.length === 0,
          },
          on: { click: _vm.prevExercise },
        },
        [
          _c("font-awesome-icon", {
            attrs: { icon: ["far", "angle-left"], size: "lg" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "exercise-cards-pagination-item",
          class: {
            inactive:
              _vm.activeExerciseIndex === _vm.exercises.length - 1 ||
              _vm.exercises.length === 0 ||
              _vm.activeExerciseIndex + 2 > _vm.exercises.length,
          },
          on: { click: _vm.nextExercise },
        },
        [
          _c("font-awesome-icon", {
            attrs: { icon: ["far", "angle-right"], size: "lg" },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }